<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper" [appDeviceClass]="'custom-scroll custom-scroll-t'">
        <div class="title_modal" (click)="log()">
            <ng-container *ngIf="!!data.tmpl; else elseTemplateAdd">
                {{ "Edit Card template" | translate }}
            </ng-container>
            <ng-template #elseTemplateAdd>
                {{ "Add Card template" | translate }}
            </ng-template>
        </div>
        <form [formGroup]="form" class="form_with_pads form_with_valids">
            <mat-form-field appearance="standard" class="full_width_form">
                <ng-container *ngIf="!form.get('name').valid && submited">
                    <div class="req_field"></div>
                    <div class="req_label">
                        <div class="angle"></div>
                        <span>
                            {{ "You need to write here" | translate }}
                        </span>
                    </div>
                </ng-container>
                <mat-label>{{ 'Template title' | translate }}</mat-label>
                <input formControlName="name" matInput placeholder="{{ 'Template title' | translate }}">
            </mat-form-field>

            <ng-container formGroupName="template_data">
                <mat-form-field appearance="standard" class="full_width_form">
                    <ng-container *ngIf="!form.get('template_data').get('name').valid && submited">
                        <div class="req_field"></div>
                        <div class="req_label">
                            <div class="angle"></div>
                            <span>
                                {{ "You need to write here" | translate }}
                            </span>
                        </div>
                    </ng-container>
                    <mat-label>{{ 'Card title' | translate }}</mat-label>
                    <input formControlName="name" matInput placeholder="{{ 'Card title' | translate }}">
                </mat-form-field>

                <div class="small_chips" *ngIf="taskStatuses?.length > 0">
                    <label>{{ "Card type" | translate }}: </label>
                    <mat-chip-list [multiple]="false" selectable formControlName="status_id">
                        <ng-container *ngFor="let status of taskStatuses; let i = index">
                            <mat-chip class="small_chip" (click)="selectType(status)" [value]="status?.id">
                                {{ status.name | translate }}
                            </mat-chip>
                        </ng-container>
                        
                    </mat-chip-list>
                </div>


                <ng-container *ngIf="form.get('template_data').get('create_automation_scenarios')">
                    <div class="small_chips">
                        <label>{{ "Choose a card scenario" | translate }}: </label>
                        <mat-chip-list [multiple]="true" selectable formControlName="create_automation_scenarios">
                            <ng-container *ngFor="let template of cardTemplates; let i = index">
                                <!-- [selected]="form.get('template_data').get('create_automation_scenarios').value.includes(template.id)" -->
                                <mat-chip style="padding-left: 12px !important;" class="chip_user" (click)="toggleCardChipTemplate(template)" [value]="template.id" [selected]="form.get('template_data').get('create_automation_scenarios').value.includes(template.id)">
                                    {{ template.name }}
                                </mat-chip>
                                <mat-chip *ngIf="i == cardTemplates.length - 1 && i > 6" class="chip_user more" (click)="cardTemplatesIdContainer.open()">
                                    {{ "more" | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
        
                    <!-- (optionSelected)=“function($event)” try this -->
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                        <mat-select [multiple]="true" #cardTemplatesIdContainer formControlName="create_automation_scenarios">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching template found' | translate }}"
                                [formControl]="cardTemplatesMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let template of cardTemplates$ | async" [value]="template.id">
                                {{template.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>
                

                <div class="small_chips" *ngIf="groups?.length > 0">
                    <label>{{ "Group" | translate }}: </label>
                    <mat-chip-list [multiple]="false" selectable formControlName="group_id">
                        <ng-container *ngFor="let group of groups; let i = index">
                            <mat-chip class="small_chip" (click)="selectGroup(group)" [value]="group?.id" [selected]="group?.id == form.get('template_data').get('group_id').value">
                                {{ group.name | translate }}
                            </mat-chip>
                            <mat-chip *ngIf="i == groups?.length - 1 && i > 6" class="small_chip more" (click)="groupIdContainer.open()">
                                {{ "More..." | translate }}
                            </mat-chip>
                        </ng-container>
                        
                    </mat-chip-list>
                </div>
    
                <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                    <mat-select #groupIdContainer formControlName="group_id" (selectionChange)="selectGroup($event)">
                        <mat-option>
                            <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching group found' | translate }}"
                            [formControl]="groupMoreControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let group of groups$ | async" [value]="group.id">
                            {{ group.name | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="box_wrp">
                    <mat-checkbox color="primary" formControlName="is_random_avatar">{{ "Use random image for card thumbnail" | translate }}</mat-checkbox>
                </div>
            </ng-container>
        </form>

        <form [formGroup]="dataForm" class="form_with_pads form_with_valids">
            <mat-form-field appearance="legacy" class="full_width_form" *ngIf="parameters">
                <mat-label>{{ "Select a grouping tag category" | translate }}</mat-label>
                <mat-select [disableOptionCentering]="true" [multiple]="false" selectDir formControlName="parameter_id">
                  <mat-option>
                    <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching tag found' | translate }}"
                        [formControl]="parametersCtrl"></ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let parameter of parameters$ | async" [value]="parameter.id">
                    {{parameter.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
        </form>

        <div class="block_w8 form_with_pads" style="margin: 20px 40px;">
            <div class="label_w8" style="margin: 0;">{{"Card Clients" | translate}}</div>
            <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                <label>{{ "Individuals" | translate }}: </label>
                <div class="chips_spacer"></div>
                <mat-chip-list [multiple]="true" selectable>
                    <ng-container *ngFor="let employee of employees; let i = index">
                        <mat-chip class="chip_user" (click)="toggleClientChip(employee)" [selected]="includesCli(employee.id)" [value]="employee.id">
                            <app-user [class]="'user_div'" [employee]="employee"></app-user>
                            <mat-icon *ngIf="!includesCli(employee.id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                            <ng-container *ngIf="includesCli(employee.id)">
                                <mat-icon style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                    #tooltip="matTooltip"
                                    matTooltip="{{'Permission to approve granted' | translate}}"
                                    [matTooltipPosition]="'above'" 
                                    (click)="setCli($event, employee.id, 0)" 
                                    *ngIf="!!getCli(employee.id)?.is_principal">thumb_up</mat-icon>
                                <mat-icon 
                                    style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                    #tooltip="matTooltip"
                                    matTooltip="{{'Permission to approve not granted' | translate}}"
                                    [matTooltipPosition]="'above'" 
                                    (click)="setCli($event, employee.id, 1)" 
                                    *ngIf="!getCli(employee.id)?.is_principal">thumb_up_off_alt</mat-icon>
                            </ng-container>
                        </mat-chip>
                        <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="cliCardEmployeeIdContainer.open()">
                            {{ "more" | translate }}
                        </mat-chip>
                    </ng-container>
                </mat-chip-list>
            </div>
    
            <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                <mat-select #cliCardEmployeeIdContainer multiple [(ngModel)]="clients_ids" (selectionChange)="toggleSelectClientChip($event)">
                    <mat-option>
                        <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching individuals found' | translate }}"
                        [formControl]="employeeMoreControl"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                        <app-user [class]="'user_div'" [employee]="employee"></app-user>
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div class="users_select" style="margin: 0 !important; width: 100% !important;">
                <label>{{ "Partners" | translate }}: </label>
                <div class="chips_spacer" *ngIf="!!pCliSwitch"></div>
                <mat-chip-list [multiple]="true" selectable *ngIf="!pCliSwitch">
                    <ng-container *ngFor="let partner of partners; let i = index">
                        <mat-chip class="chip_user" (click)="toggleClientPartnerChip(partner)" [selected]="includesCliPartn(partner.partner_company_id)" [value]="partner.partner_company_id">
                            <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                            <mat-icon *ngIf="!includesCliPartn(partner.partner_company_id)" style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px; visibility: hidden;"></mat-icon>
                            <ng-container *ngIf="includesCliPartn(partner.partner_company_id)">
                                <mat-icon 
                                #tooltip="matTooltip"
                                matTooltip="{{'Permission to approve granted' | translate}}"
                                [matTooltipPosition]="'above'" 
                                style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                (click)="setCliPartn($event, partner.partner_company_id, 0)" 
                                *ngIf="!!getCliPartn(partner.partner_company_id)?.is_principal">thumb_up</mat-icon>
                                <mat-icon 
                                #tooltip="matTooltip"
                                matTooltip="{{'Permission to approve not granted' | translate}}"
                                [matTooltipPosition]="'above'" 
                                style="margin-left: 3.5px; width: 14px; height: 14px; line-height: 14px; font-size: 14px;" 
                                (click)="setCliPartn($event, partner.partner_company_id, 1)" 
                                *ngIf="!getCliPartn(partner.partner_company_id)?.is_principal">thumb_up_off_alt</mat-icon>
                            </ng-container>
                        </mat-chip>
                        <mat-chip *ngIf="i == partners.length - 1 && i > 6" class="chip_user more" (click)="cliCardPartnersIdContainer.open()">
                            {{ "more" | translate }}
                        </mat-chip>
                    </ng-container>
                </mat-chip-list>
            </div>
    
            <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                <mat-select #cliCardPartnersIdContainer multiple [(ngModel)]="partnerClients_ids" (selectionChange)="toggleSelectClientPartnerChip($event)">
                    <mat-option>
                        <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching partners found' | translate }}"
                        [formControl]="partnersControl"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let partner of partners$ | async" [value]="partner.partner_company_id">
                        <app-user [class]="'user_div'" [companyEmployee]="partner?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="form_with_pads">

            <ng-container *ngFor="let param of parameters">
    
                <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                    <mat-label>{{ param.name }}</mat-label>
        
                    <mat-chip-list 
                        class="without_ordered"
                        #paramsChipList
                        [(ngModel)]="param.taskActiveValues"
                    >
                        <mat-chip 
                            class="param_chip"
                            *ngFor="let val of param.taskActiveValues; let k = index;"
                            [removable]="true" 
                            color="primary" 
                            (removed)="onRemove(val.id, param, k)">
                                {{ val?.value }}
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
        
                        <input
                        id="param_input_{{param.id}}"
                        class="auto_complete_input"
                        placeholder="{{ 'Search' | translate }}"
                        #paramsInput
                        [formControl]="param.search"
                        [matAutocomplete]="paramsAuto"
                        [matChipInputFor]="paramsChipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                        (matChipInputTokenEnd)="add($event)">
                    </mat-chip-list>
                    <mat-autocomplete autoActiveFirstOption #paramsAuto="matAutocomplete" (optionSelected)="selectedTask($event, param)" (optionsScroll)="onScroll(param)">
                        <ng-container *ngFor="let val of param.values">
                            <mat-option *ngIf="noOption(param.taskActiveValues, val.id) && withSearch(param?.search?.value, val)" [value]="val.id">
                                {{ val.value }}
                            </mat-option>
                        </ng-container>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>
        </div>

        <div class="jobs_wrp form_with_pads">
            <div class="job" *ngFor="let job of jobs; let i = index;">

                <!-- <span (click)="logJob(job)">log job</span> -->
                <mat-form-field appearance="standard" class="full_width_form">
                    <mat-label>{{ 'Title' | translate }}</mat-label>
                    <input [(ngModel)]="job.name" matInput placeholder="{{ 'Title' | translate }}">
                </mat-form-field>
    
                <mat-form-field appearance="standard" class="full_width_form">
                    <mat-label>{{ 'Description' | translate }}</mat-label>
                    <textarea [(ngModel)]="job.comment" matInput placeholder="{{ 'Drief description' | translate }}"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"></textarea>
                </mat-form-field>

                <ng-container *ngIf="operations?.length > 0">
                    <div class="small_chips" >
                        <label>{{ "Job type" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.operation_id">
                            <ng-container *ngFor="let operation of operations; let i = index">
                                <mat-chip class="small_chip" (click)="job.operation_id = operation?.id" [value]="operation?.id" [selected]="job.operation_id == operation?.id">
                                    {{ operation.name | translate }}
                                </mat-chip>
                                <mat-chip *ngIf="i == operations?.length - 1 && i > 6" class="small_chip more" (click)="operationIdContainer.open()">
                                    {{ "More..." | translate }}
                                </mat-chip>
                            </ng-container>
                            
                        </mat-chip-list>
                    </div>
        
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                        <mat-select #operationIdContainer [(ngModel)]="job.operation_id">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching job type found' | translate }}"
                                [formControl]="operationMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let operation of operations$ | async" [value]="operation.id">
                                {{ operation.name | translate }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </ng-container>

                <div class="small_chips" *ngIf="statuses?.length > 0">
                    <label>{{ "Status" | translate }}: </label>
                    <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.status_id">
                        <ng-container *ngFor="let status of statuses">
                            <mat-chip class="small_chip" (click)="job.status_id = status.id" [selected]="job.status_id == status.id" [value]="status?.id" [ngClass]="{
                                'first': status.id == '1',
                                'second': status.id == '2',
                                'third': status.id == '3',
                                'fours': status.id == '4',
                                'fives': status.id == '5',
                                'sixs': status.id == '6',
                                'nine': status.id == '97',
                                'seven': status.id == '98',
                                'eight': status.id == '99'}">
                                {{ status.name | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div>      
                
                <div class="priority_chips">
                    <label>{{ "Priority" | translate }}: </label>
                    <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.priority">
                        <mat-chip *ngFor="let priority of prioritys" [selected]="job.priority == priority.id" [ngClass]="{
                            'Urgent': priority.id == '1000',
                            'High': priority.id == '900',
                            'Middle': priority.id == '800',
                            'Low': priority.id == '700',
                            'No': priority.id == '0'
                        }" class="priority_chip" (click)="job.priority = priority.id" [value]="priority.id">
                            {{ priority.name | translate }}
                        </mat-chip>
                    </mat-chip-list>
                </div>

                <div class="small_chips">
                    <label>{{ "Choose a scenario" | translate }}: </label>
                    <mat-chip-list [multiple]="true" selectable [(ngModel)]="job.create_automation_scenarios">
                        <ng-container *ngFor="let template of templates; let i = index">
                            <mat-chip style="padding-left: 12px !important;" class="chip_user" (click)="toggleChipTemplate(template, job)" [value]="template.id" [selected]="job.create_automation_scenarios.includes(template.id)">
                                {{ template.name }}
                            </mat-chip>
                            <mat-chip *ngIf="i == templates.length - 1 && i > 6" class="chip_user more" (click)="templatesIdContainer.open()">
                                {{ "more" | translate }}
                            </mat-chip>
                        </ng-container>
                    </mat-chip-list>
                </div>
    
                <!-- (optionSelected)=“function($event)” try this -->
                <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                    <mat-select [multiple]="true" #templatesIdContainer [(ngModel)]="job.create_automation_scenarios">
                        <mat-option>
                            <ngx-mat-select-search 
                            placeholderLabel="{{ 'Search' | translate }}" 
                            noEntriesFoundLabel="{{ 'no matching template found' | translate }}"
                            [formControl]="templatesMoreControl"></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let template of templates$ | async" [value]="template.id">
                            {{template.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="file_tags_out" style="padding-bottom: 18px;">
                    <label>{{ "Job Tags" | translate }}: </label>
                    <div class="file_tags">
                        <ng-container *ngIf="job.parameters && job.parameters.length && job.parameters[0] && job.parameters[0].activeValues && job.parameters[0].activeValues.length">
                            <div class="file_tag" *ngFor="let tag of job.parameters[0].activeValues; let t = index;">
                                <mat-icon class="verified" (click)="togglePrimary(tag)" [ngClass]="{'cst_primary': !!tag.is_primary}">verified</mat-icon>
                                {{tag.value}}
                                <div class="remove_out">
                                    <div class="remove" (click)="onRemoveJobTag(job, tag, t)">
                                        <svg style="width: 5px; height: 5px;" width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5 0.503571L4.49643 0L2.5 1.99643L0.503571 0L0 0.503571L1.99643 2.5L0 4.49643L0.503571 5L2.5 3.00357L4.49643 5L5 4.49643L3.00357 2.5L5 0.503571Z" fill="white"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <div class="add_tag cp" (click)="openTargetValues(job)">
                            <svg style="width: 16px; height: 16px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 8.8H8.8V12H7.2V8.8H4V7.2H7.2V4H8.8V7.2H12M8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z" fill="#C4C4C4"/>
                            </svg>
                            {{ "Tag" | translate }}
                        </div>
                    </div>
                </div>
                
                <!-- <ng-container *ngFor="let param of parameters">
    
                    <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!param?.hasValues">
                        <mat-label>{{ param.name }}</mat-label>
            
                        <mat-chip-list 
                            class="without_ordered"
                            #paramsJobChipList
                        >
                            <mat-chip 
                                class="param_chip"
                                *ngFor="let val of forArray(job.create_parameter_values_to_task, param.id); let k = index;"
                                [removable]="true" 
                                color="primary" 
                                (removed)="onRemoveJobParameter(val.parameter_value_id, param, job, k)">
                                    {{ getValueById(val.parameter_value_id)?.value }}
                                <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip>
            
                            <input
                            id="job_{{k}}_param_input_{{param.id}}"
                            class="auto_complete_input"
                            placeholder="{{ 'Search' | translate }}"
                            #paramsInput
                            [formControl]="param.search"
                            [matAutocomplete]="jobParamsAuto"
                            [matChipInputFor]="paramsJobChipList"
                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="add($event)">
                        </mat-chip-list>
                        <mat-autocomplete autoActiveFirstOption #jobParamsAuto="matAutocomplete" (optionSelected)="selectedJob($event, job, param, k)" (optionsScroll)="onScroll(param)">
                            <ng-container *ngFor="let val of param.values">
                                <mat-option *ngIf="noOptionJob(forArray(job.create_parameter_values_to_task, param.id), val.id) && withSearch(param?.search?.value, val)" [value]="val.id">
                                    {{ val.value }}
                                </mat-option>
                            </ng-container>
                        </mat-autocomplete>
                    </mat-form-field>
                </ng-container> -->


                <div class="job_executors">
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_employee">
                        {{ "Assign by executor settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_employee')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_employee_assistant">
                        {{ "Assign by assistant settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_employee_assistant')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_client">
                        {{ "Assign by client settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_client')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_client_principal">
                        {{ "Assign by client moderator settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_client_principal')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_partner">
                        {{ "Assign by partner settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_partner')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_partner_assistant">
                        {{ "Assign by partner assistant settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_partner_assistant')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_partner_client">
                        {{ "Assign by partner client settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_partner_client')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                    <div class="executor" *ngIf="!!job.is_automation_employee_position_task_partner_client_principal">
                        {{ "Assign by partner client moderator settings" | translate }}

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteRole(job, 'is_automation_employee_position_task_partner_client_principal')">
                            <mat-icon>person_remove</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="job_executors" *ngIf="job.create_task_employees.length && employees && employees.length > 0">
                    <div class="executor" *ngFor="let executor of job.create_task_employees; let k = index;">
                        
                        <app-user [class]="'user_div'" [employee]="getEmployeeById(executor.employee_id)"></app-user>
                       
                        <p>
                            {{ "Choose member role" | translate }}:
                            <mat-button-toggle-group appearance="legacy" class="ml-1" [(ngModel)]="executor.is_manager" [value]="executor.is_manager">
                                <mat-button-toggle [value]="1">{{ "Executor" | translate }}</mat-button-toggle>
                                <mat-button-toggle [value]="0">{{ "Assistant" | translate }}</mat-button-toggle>
                            </mat-button-toggle-group>
                        </p> 

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deleteExecutor(job, k)">
                            <mat-icon>person_remove</mat-icon>
                        </button>

                    </div>
                </div>

                <div class="job_executors" *ngIf="job.create_task_partners.length && partners && partners.length > 0">
                    <div class="executor" *ngFor="let executor of job.create_task_partners; let k = index;">
                        <app-user [class]="'user_div'" [companyEmployee]="getPartnerById(executor.partner_company_id)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                       
                        <p>
                            {{ "Choose partner role" | translate }}:
                            <mat-button-toggle-group appearance="legacy" class="ml-1" [(ngModel)]="executor.is_manager" [value]="executor.is_manager">
                                <mat-button-toggle [value]="1">{{ "Executor" | translate }}</mat-button-toggle>
                                <mat-button-toggle [value]="0">{{ "Assistant" | translate }}</mat-button-toggle>
                            </mat-button-toggle-group>
                        </p> 

                        <button mat-icon-button color="warn" class="delete_executor" (click)="deletePartner(job, k)">
                            <mat-icon>person_remove</mat-icon>
                        </button>

                    </div>
                </div>

                <div class="job_executors" *ngIf="job.create_task_clients && job.create_task_clients.length && ((employees && employees.length > 0) || (partners && partners.length > 0))">
                    <div class="executor" *ngFor="let executor of job.create_task_clients; let k = index;">
                        <ng-container *ngIf="!!executor.client_partner_company_id; else elseTemplateCliP">
                            <app-user [class]="'user_div'" [companyEmployee]="getPartnerById(executor.client_partner_company_id)?.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                           
                            <p>
                                {{ "Choose partner client role" | translate }}:
                                <mat-button-toggle-group appearance="legacy" class="ml-1" [(ngModel)]="executor.is_principal" [value]="executor.is_principal">
                                    <mat-button-toggle [value]="1">{{ "Can moderate" | translate }}</mat-button-toggle>
                                    <mat-button-toggle [value]="0">{{ "Only view" | translate }}</mat-button-toggle>
                                </mat-button-toggle-group>
                            </p> 
    
                            <button mat-icon-button color="warn" class="delete_executor" (click)="deleteClient(job, k)">
                                <mat-icon>person_remove</mat-icon>
                            </button>
                        </ng-container>
                        <ng-template #elseTemplateCliP>
                            <app-user [class]="'user_div'" [employee]="getEmployeeById(executor.client_employee_id)"></app-user>
                       
                            <p>
                                {{ "Choose client role" | translate }}:
                                <mat-button-toggle-group appearance="legacy" class="ml-1" [(ngModel)]="executor.is_principal" [value]="executor.is_principal">
                                    <mat-button-toggle [value]="1">{{ "Can moderate" | translate }}</mat-button-toggle>
                                    <mat-button-toggle [value]="0">{{ "Only view" | translate }}</mat-button-toggle>
                                </mat-button-toggle-group>
                            </p> 
    
                            <button mat-icon-button color="warn" class="delete_executor" (click)="deleteClient(job, k)">
                                <mat-icon>person_remove</mat-icon>
                            </button>
                        </ng-template>

                    </div>
                </div>
                

                <div class="box_wrp">
                    <mat-checkbox color="primary" [(ngModel)]="job.is_skip_task_channel_with_url">{{ "Ignore if contains a link?" | translate }}</mat-checkbox>
                </div>
  
                <div class="box_wrp">
                    <mat-checkbox color="primary" (change)="changeCreateDiscussionFlag($event, job)" [(ngModel)]="job.is_create_discussions">{{ "Chats will be created based on the outlets in the card" | translate }}</mat-checkbox>
                </div>

                <mat-form-field appearance="standard" class="full_width_form" *ngIf="!!job.is_create_discussions">
                    <mat-label>{{ "Discussion name template" | translate }}</mat-label>
                    <input [(ngModel)]="job.discussion_name_template" matInput>
                    <mat-hint>{{ "Use params channel_name and platform_name in this field with curly brackets" | translate }}</mat-hint>
                </mat-form-field>

                <div class="form_with_pads form_with_valids" *ngIf="!!job.is_create_discussions">
                    <div class="profile_add d-f-c" *ngIf="job?.addProfiles">
                        <mat-form-field appearance="standard" class="full_width_form">
                            <mat-label>{{ "Select publication outlet" | translate }}</mat-label>
                            <mat-select [disableOptionCentering]="true" selectDir [(ngModel)]="job.addProfiles" multiple>
                                <mat-select-trigger class="multi_users">
                                    <ng-container *ngIf="job.addProfiles && job.addProfiles.length">
                                        <ng-container *ngFor="let id of job.addProfiles">
                                            <span>
                                                <app-outlet-line [channel]="getProfileById(id)" [company_id]="company_id"></app-outlet-line>
                                            </span>
                                        </ng-container>
                                    </ng-container>
                                </mat-select-trigger>
                                <mat-option>
                                    <ngx-mat-select-search 
                                    placeholderLabel="{{ 'Search' | translate }}" 
                                    noEntriesFoundLabel="{{ 'no matching outlet found' | translate }}"
                                    [formControl]="profilesMoreControl"></ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let profile of profiles$ | async" [value]="profile.id" class="cst_o">
                                    <app-outlet-line [channel]="profile" [company_id]="company_id"></app-outlet-line>
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div class="add_profile" (click)="addChannels(job)" [ngClass]="{'disabled': !job.addProfiles.length}">
                            + {{ (job?.addProfiles.length == 1 ? 'Outlet' : 'Outlets') | translate }}
                        </div>
                    </div>
                    <div class="profile_row" *ngFor="let profile of job.addedProfiles">
                        <div>
                            <app-outlet-line [channel]="profile" [company_id]="company_id"></app-outlet-line>
                            <mat-checkbox class="parameter_check" [(ngModel)]="profile.is_common_parameter_value">{{ "Create a chat if the job and the channel have common parameter values" | translate }}</mat-checkbox>
                        </div>
                        <div class="empls">
                            <div class="users_select">
                                <label style="font-weight: 300;">{{ "Choose an employees" | translate }}: </label>
                                <mat-chip-list [multiple]="true" selectable [(ngModel)]="profile.employees_ids">
                                    <ng-container *ngFor="let employee of employees; let i = index">
                                        <mat-chip class="chip_user" (click)="toggleEmpl(employee, profile)" [value]="employee.id">
                                            <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                        </mat-chip>
                                        <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="emploeeProfileContainer.open()">
                                            {{ "more" | translate }}
                                        </mat-chip>
                                    </ng-container>
                                </mat-chip-list>
                            </div>
                
                            <mat-form-field appearance="standard" class="full_width_form hide-form-field">
                                <mat-select class="full_width_form hide-form-field" #emploeeProfileContainer [(ngModel)]="profile.employees_ids" multiple>
                                    <mat-option>
                                        <ngx-mat-select-search 
                                        placeholderLabel="{{ 'Search' | translate }}" 
                                        noEntriesFoundLabel="{{ 'no matching executor found' | translate }}"
                                        [formControl]="employeeMoreControl"></ngx-mat-select-search>
                                    </mat-option>
                                    <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id">
                                        <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <button mat-icon-button color="warn" class="delete_profile" (click)="deleteChannel(job, profile)">
                            <mat-icon>do_disturb_on</mat-icon>
                        </button>
                    </div>
                </div>

                <button mat-icon-button color="warn" class="delete_job" (click)="deleteJob(i)">
                    <mat-icon>do_disturb_on</mat-icon>
                </button>

                <div class="add_new_executor" *ngIf="job.newExecutor" style="position: relative;">
                    <div class="users_select">
                        <label>{{ "Add new executor" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.newExecutor.employee_id">
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_employee ? null : toggleVal(job, 'add_exec', 'is_automation_employee_position_task_employee')" [selected]="job?.add_exec == 'is_automation_employee_position_task_employee'" [disabled]="!!job.is_automation_employee_position_task_employee">
                                {{ "Assign by executor settings" | translate }}
                            </mat-chip>
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_employee_assistant ? null : toggleVal(job, 'add_exec', 'is_automation_employee_position_task_employee_assistant')" [selected]="job?.add_exec == 'is_automation_employee_position_task_employee_assistant'" [disabled]="!!job.is_automation_employee_position_task_employee_assistant">
                                {{ "Assign by assistant settings" | translate }}
                            </mat-chip>
                            <ng-container *ngFor="let employee of employees; let i = index">
                                <mat-chip class="chip_user" (click)="!checkIfDisabled(job, employee.id) ? job.newExecutor.employee_id = employee.id : null; job.add_exec = ''" [selected]="job.newExecutor.employee_id == employee.id" [value]="employee.id" [disabled]="checkIfDisabled(job, employee.id)">
                                    <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                </mat-chip>
                                <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="employeeIdContainer.open()">
                                    {{ "more" | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
        
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field" style="position: absolute;">
                        <mat-select #employeeIdContainer [(ngModel)]="job.newExecutor.employee_id" (selectionChange)="job.add_exec = ''">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching executor found' | translate }}"
                                [formControl]="employeeMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id" [ngClass]="{'opacity-6': checkIfDisabled(job, employee.id)}" [disabled]="checkIfDisabled(job, employee.id)">
                                <app-user [class]="'user_div'" [employee]="employee"></app-user>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button mat-icon-button color="primary" (click)="addExecutor(job)">
                        <mat-icon>person_add</mat-icon>
                    </button>

                </div>
                <div class="add_new_executor" *ngIf="job.newPartner" style="position: relative;">
                    <div class="users_select">
                        <label>{{ "Add new partner" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.newPartner.partner_company_id">
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_partner ? null : toggleVal(job, 'add_p_exec', 'is_automation_employee_position_task_partner')" [selected]="job?.add_p_exec == 'is_automation_employee_position_task_partner'" [disabled]="!!job.is_automation_employee_position_task_partner">
                                {{ "Assign by partner settings" | translate }}
                            </mat-chip>
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_partner_assistant ? null : toggleVal(job, 'add_p_exec', 'is_automation_employee_position_task_partner_assistant')" [selected]="job?.add_p_exec == 'is_automation_employee_position_task_partner_assistant'" [disabled]="!!job.is_automation_employee_position_task_partner_assistant">
                                {{ "Assign by partner assistant settings" | translate }}
                            </mat-chip>
                            <ng-container *ngFor="let partner of partners; let i = index">
                                <mat-chip class="chip_user" (click)="!checkIfPartnerDisabled(job, partner.partner_company_id) ? job.newPartner.partner_company_id = partner.partner_company_id : null; job.add_p_exec = ''" [selected]="job.newPartner.partner_company_id == partner.partner_company_id" [value]="partner.partner_company_id" [disabled]="checkIfPartnerDisabled(job, partner.partner_company_id)">
                                    <app-user [class]="'user_div'" [companyEmployee]="partner.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                                </mat-chip>
                                <mat-chip *ngIf="i == partners.length - 1 && i > 6" class="chip_user more" (click)="partnerIdContainer.open()">
                                    {{ "more" | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
        
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field" style="position: absolute;">
                        <mat-select #partnerIdContainer [(ngModel)]="job.newPartner.partner_company_id" (selectionChange)="job.add_p_exec = ''">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching partner found' | translate }}"
                                [formControl]="partnersControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let partner of partners$ | async" [value]="partner.partner_company_id" [ngClass]="{'opacity-6': checkIfPartnerDisabled(job, partner.partner_company_id)}" [disabled]="checkIfPartnerDisabled(job, partner.partner_company_id)">
                                <app-user [class]="'user_div'" [companyEmployee]="partner.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button mat-icon-button color="primary" (click)="addPartner(job)">
                        <mat-icon>person_add</mat-icon>
                    </button>

                </div>
                <div class="add_new_executor" *ngIf="job.newClientExec" style="position: relative;">
                    <div class="users_select">
                        <label>{{ "Add new client" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.newClientExec.client_employee_id">
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_client_principal ? null : toggleVal(job, 'add_c_exec', 'is_automation_employee_position_task_client_principal')" [selected]="job?.add_c_exec == 'is_automation_employee_position_task_client_principal'" [disabled]="!!job.is_automation_employee_position_task_client_principal">
                                {{ "Assign by client moderator settings" | translate }}
                            </mat-chip>
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_client ? null : toggleVal(job, 'add_c_exec', 'is_automation_employee_position_task_client')" [selected]="job?.add_c_exec == 'is_automation_employee_position_task_client'" [disabled]="!!job.is_automation_employee_position_task_client">
                                {{ "Assign by client settings" | translate }}
                            </mat-chip>
                            <ng-container *ngFor="let employee of employees; let i = index">
                                <mat-chip class="chip_user" (click)="!checkCliIfDisabled(job, employee.id) ? job.newClientExec.client_employee_id = employee.id : null; job.add_c_exec = ''" [selected]="job.newClientExec.client_employee_id == employee.id" [value]="employee.id" [disabled]="checkCliIfDisabled(job, employee.id)">
                                    <app-user [class]="'user_div'" [employee]="employee"></app-user>
                                </mat-chip>
                                <mat-chip *ngIf="i == employees.length - 1 && i > 6" class="chip_user more" (click)="cliEmployeeIdContainer.open()">
                                    {{ "more" | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
        
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field" style="position: absolute;">
                        <mat-select #cliEmployeeIdContainer [(ngModel)]="job.newClientExec.client_employee_id" (selectionChange)="job.add_c_exec = ''">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching executor found' | translate }}"
                                [formControl]="employeeMoreControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let employee of employees$ | async" [value]="employee.id" [ngClass]="{'opacity-6': checkCliIfDisabled(job, employee.id)}" [disabled]="checkCliIfDisabled(job, employee.id)">
                                <app-user [class]="'user_div'" [employee]="employee"></app-user>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button mat-icon-button color="primary" (click)="addClient(job, 'client_employee_id')">
                        <mat-icon>person_add</mat-icon>
                    </button>

                </div>
                <div class="add_new_executor" *ngIf="job.newClientPartn" style="position: relative;">
                    <div class="users_select">
                        <label>{{ "Add new partner client" | translate }}: </label>
                        <mat-chip-list [multiple]="false" selectable [(ngModel)]="job.newClientPartn.client_partner_company_id">
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_partner_client_principal ? null : toggleVal(job, 'add_c_p_exec', 'is_automation_employee_position_task_partner_client_principal')" [selected]="job?.add_c_p_exec == 'is_automation_employee_position_task_partner_client_principal'" [disabled]="!!job.is_automation_employee_position_task_partner_client_principal">
                                {{ "Assign by partner client moderator settings" | translate }}
                            </mat-chip>
                            <mat-chip class="chip_user" style="padding-left: 12px !important; order: -10 !important;" (click)="!!job.is_automation_employee_position_task_partner_client ? null : toggleVal(job, 'add_c_p_exec', 'is_automation_employee_position_task_partner_client')" [selected]="job?.add_c_p_exec == 'is_automation_employee_position_task_partner_client'" [disabled]="!!job.is_automation_employee_position_task_partner_client">
                                {{ "Assign by partner client settings" | translate }}
                            </mat-chip>
                            <ng-container *ngFor="let partner of partners; let i = index">
                                <mat-chip class="chip_user" (click)="!checkIfCliPartnerDisabled(job, partner.partner_company_id) ? job.newClientPartn.client_partner_company_id = partner.partner_company_id : null; job.add_c_p_exec = ''" [selected]="job.newClientPartn.client_partner_company_id == partner.partner_company_id" [value]="partner.partner_company_id" [disabled]="checkIfCliPartnerDisabled(job, partner.partner_company_id)">
                                    <app-user [class]="'user_div'" [companyEmployee]="partner.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                                </mat-chip>
                                <mat-chip *ngIf="i == partners.length - 1 && i > 6" class="chip_user more" (click)="cliPartnerIdContainer.open()">
                                    {{ "more" | translate }}
                                </mat-chip>
                            </ng-container>
                        </mat-chip-list>
                    </div>
        
                    <mat-form-field appearance="standard" class="full_width_form hide-form-field" style="position: absolute;">
                        <mat-select #cliPartnerIdContainer [(ngModel)]="job.newClientPartn.client_partner_company_id" (selectionChange)="job.add_c_p_exec = ''">
                            <mat-option>
                                <ngx-mat-select-search 
                                placeholderLabel="{{ 'Search' | translate }}" 
                                noEntriesFoundLabel="{{ 'no matching partner found' | translate }}"
                                [formControl]="partnersControl"></ngx-mat-select-search>
                            </mat-option>
                            <mat-option *ngFor="let partner of partners$ | async" [value]="partner.partner_company_id" [ngClass]="{'opacity-6': checkIfCliPartnerDisabled(job, partner.partner_company_id)}" [disabled]="checkIfCliPartnerDisabled(job, partner.partner_company_id)">
                                <app-user [class]="'user_div'" [companyEmployee]="partner.partnerCompany" [imgRoute]="imgRoute" [host]="host" [company]="data?.company"></app-user>
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button mat-icon-button color="primary" (click)="addClient(job, 'client_partner_company_id')">
                        <mat-icon>person_add</mat-icon>
                    </button>

                </div>
            </div>
        </div>

        <div class="f_w_p_btns dbl">
            <div class="add_job" (click)="addJob()">
                + {{ 'Add job' | translate }}
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div class="f_w_p_btns">
        <button mat-button (click)="close()">
            {{ "Close" | translate }}
        </button>
        <button class="ml-1 d-f-btn" (click)="onSubmit()" cdkFocusInitial mat-raised-button color="primary" [disabled]="isSubmit">
            <mat-spinner class="spin_16 mr-1" *ngIf="isSubmit"></mat-spinner>
            <ng-container *ngIf="!!data.tmpl; else elseTemplateAddSbmt">
                {{ "Edit" | translate }}
            </ng-container>
            <ng-template #elseTemplateAddSbmt>
                {{ "Add" | translate }}
            </ng-template>
        </button>
    </div>
</mat-dialog-actions>